import { render, staticRenderFns } from "./ExportProducts.vue?vue&type=template&id=2f5fdbb6&"
import script from "./ExportProducts.vue?vue&type=script&lang=js&"
export * from "./ExportProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports